import React, { useState, forwardRef, useEffect } from "react";

import { InputTextarea } from "primereact/inputtextarea";
import MeaUpdateModal from "../../../../components/MeaUpdateModal";
import studentsAPI from "../../../../services/students";

const UpdateRegistrationConfirmationDetailsModal = forwardRef((props, ref) => {
  const [registrationConfirmationDetails, setRegistrationConfirmationDetails] = useState("");

  useEffect(() => {
    setRegistrationConfirmationDetails(props?.student?.registration_confirmation_details);
  }, [props]);

  return (
    <>
      <MeaUpdateModal
        ref={ref}
        title="Détails de confirmation"
        serviceAPI={studentsAPI}
        id={props?.student?.id}
        schoolId={props?.schoolId}
        trainingId={props?.trainingId}
        data={{
          registration_confirmation_details: registrationConfirmationDetails,
        }}
      >
        <InputTextarea
          value={registrationConfirmationDetails || ""}
          className="w-full"
          onChange={(e) => {
            setRegistrationConfirmationDetails(e.target.value);
          }}
          rows={5}
          autoResize
        />
      </MeaUpdateModal>
    </>
  );
});

export default UpdateRegistrationConfirmationDetailsModal;
